import { useState } from "react";
import StatsGrid from "./StatsGrid";
import FiltersBar from "./FiltersBar";
import EscalationsTable from "./EscalationsTable";
import DetailModal from "./DetailModal";
import { ESCALATION_TYPES, STATUS_OPTIONS } from "../../constants/translations";
import { getTypeLabel, getStatusLabel } from "../../utils/helpers";

/**
 * My-Escalations tab — orchestrates stats, filters, table, and detail modal.
 *
 * Props:
 *   loading     {boolean}
 *   escalations {array}
 *   stats       {object}
 *   screenSize  {string}
 *   language    {"en"|"ar"}
 *   t           {object}
 *   theme       {string}
 *   styles      {object}
 *   fonts       {object}
 *   StatusBadge {component}
 */
const MyEscalationsTable = ({
  loading,
  escalations,
  stats,
  screenSize,
  language,
  t,
  theme,
  styles,
  fonts,
  StatusBadge,
}) => {
  const [selectedType, setSelectedType] = useState("all");
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [sortOrder, setSortOrder] = useState("desc");
  const [currentEscalation, setCurrentEscalation] = useState(null);

  const getFiltered = () => {
    let filtered = [...escalations];

    if (selectedType !== "all") {
      filtered = filtered.filter(
        (e) => e.type?.toLowerCase() === selectedType.toLowerCase()
      );
    }
    if (selectedStatus !== "all") {
      filtered = filtered.filter((e) => e.status === selectedStatus);
    }

    filtered.sort((a, b) => {
      const da = new Date(a.issuedAt);
      const db = new Date(b.issuedAt);
      return sortOrder === "desc" ? db - da : da - db;
    });

    return filtered;
  };

  return (
    <>
      <StatsGrid
        stats={stats}
        theme={theme}
        screenSize={screenSize}
        styles={styles}
        fonts={fonts}
        t={t}
      />

      <FiltersBar
        selectedType={selectedType}
        setSelectedType={setSelectedType}
        selectedStatus={selectedStatus}
        setSelectedStatus={setSelectedStatus}
        sortOrder={sortOrder}
        setSortOrder={setSortOrder}
        theme={theme}
        screenSize={screenSize}
        fonts={fonts}
        styles={styles}
        language={language}
        t={t}
      />

      <EscalationsTable
        escalations={getFiltered()}
        loading={loading}
        theme={theme}
        screenSize={screenSize}
        fonts={fonts}
        styles={styles}
        language={language}
        t={t}
        StatusBadge={({ status }) => (
          <StatusBadge status={status} t={t} screenSize={screenSize} fonts={fonts} />
        )}
        onViewDetails={setCurrentEscalation}
      />

      {currentEscalation && (
        <DetailModal
          escalation={currentEscalation}
          onClose={() => setCurrentEscalation(null)}
          theme={theme}
          screenSize={screenSize}
          styles={styles}
          language={language}
          t={t}
          StatusBadge={({ status }) => (
            <StatusBadge status={status} t={t} screenSize={screenSize} fonts={fonts} />
          )}
        />
      )}
    </>
  );
};

export default MyEscalationsTable;